var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27.994,
    viewBox: "0 0 28 27.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10695",
    "data-name": "Group 10695",
    transform: "translate(11544 22585)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8680",
    "data-name": "Rectangle 8680",
    width: 28,
    height: 27.995,
    rx: 13.998,
    transform: "translate(-11544 -22585)",
    fill: "#faac26",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-11617.8 -22659.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19434",
    "data-name": "Path 19434",
    d: "M79.8,88.63a8.133,8.133,0,1,1,8.043,8.135A8.149,8.149,0,0,1,79.8,88.63Zm8.1,6.659a6.652,6.652,0,1,0-6.622-6.7A6.665,6.665,0,0,0,87.9,95.289Z",
    transform: "translate(0 0)",
    fill: "#faac26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19435",
    "data-name": "Path 19435",
    d: "M239.676,147.048c0-.63,0-1.261,0-1.891a.653.653,0,0,1,.625-.588.733.733,0,0,1,.81.44,1.075,1.075,0,0,1,.032.272c0,1.066,0,2.136,0,3.2a.332.332,0,0,0,.134.28c.611.506,1.217,1.023,1.828,1.533a.564.564,0,0,1,.231.607.784.784,0,0,1-1.212.323c-.162-.121-.315-.257-.467-.389-.569-.479-1.134-.957-1.7-1.428a.686.686,0,0,1-.282-.572c0-.6,0-1.191,0-1.79Z",
    transform: "translate(-152.477 -59.809)",
    fill: "#faac26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.7b84ab240ec265235a1d2c693561fb3d.svg";
export { ForwardRef as ReactComponent };